import Logger from '../logger';

var LOGGING_EVENTS = {
    LOG_IN: 'loggedIn',
    LOG_OUT: 'loggedOut'
};

var SIGN_IN_URLS = [
    'orange.pl/moj-orange/(rejestracja|uslugi-komorkowe|uslugi-pakietowe|uslugi-na-karte|uslugi-stacjonarne|problem-techniczny)?',
    'orange(.binaries)?.pl/ui/[0-9]{8}/gwidget/',
    'gchat.orange.pl/server/resources/locale/',
    'orange.pl/pwa/indus_1'
];

var SIGN_IN_REFERRERS = [
    '',
    'orange.pl/zaloguj.phtml',
    'orange.pl/zalogowanie.phtml',
    'orange.pl/twojekonto/',
    'orange.pl/moj-orange/(rejestracja|uslugi-komorkowe|uslugi-pakietowe|uslugi-na-karte|uslugi-stacjonarne|problem-techniczny)?'
];

var SIGN_OUT_URLS = ['orange.pl/twojekonto/'];

const getURLMatch = (baseURL, u) => baseURL.match(new RegExp(`^http[s]{0,1}://(www.)?${u}`, 'g'));

const detectLogging = (url, referrer, currentUserStatus) => {
    var event = null;
    if (
        SIGN_OUT_URLS.some((u) => getURLMatch(url, u)) &&
        currentUserStatus === LOGGING_EVENTS.LOG_IN
    ) {
        event = LOGGING_EVENTS.LOG_OUT;
    }
    if (
        !event &&
        SIGN_IN_URLS.some((u) => getURLMatch(url, u)) &&
        SIGN_IN_REFERRERS.some((u) => (u === '' ? referrer === u : getURLMatch(referrer, u)))
    ) {
        event = LOGGING_EVENTS.LOG_IN;
    }
    return event;
};

const getLoggingChange = (currentUserStatus) => {
    let event = detectLogging(document.URL, document.referrer, currentUserStatus);
    Logger.log(
        `logged state => ${currentUserStatus} (url=${document.URL}, ref=${document.referrer}, event=${event})`
    );
    return event;
};

export { getLoggingChange, detectLogging, LOGGING_EVENTS };
